import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cx } from "@/shared/lib/cx";

export interface TextareaProps extends Omit<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  "value" | "onChange"
> {
  value: string;
  onChange: (value: string) => void;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { value, onChange, className, ...props },
  ref,
) {
  return (
    <textarea
      ref={ref}
      className={cx("textarea", className)}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      {...props}
    />
  );
});
